import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, waLink } from "@/lib/config";
import { CheckCircle2 } from "lucide-react";

export default function BookingSuccessPage() {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    if (bookingId) {
      api.get(`/bookings/${bookingId}`).then((r) => setBooking(r.data)).catch(() => {});
    }
  }, [bookingId]);

  return (
    <div data-testid="booking-success-page" className="pt-36 md:pt-40 pb-24 min-h-[80vh] bg-[#FAF6F0]">
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-[#A6521B]/12 text-[#A6521B] rounded-full mb-8">
          <CheckCircle2 size={40} />
        </div>
        <p className="overline">karibu sana</p>
        <h1 className="font-display text-5xl md:text-7xl italic font-light mt-4 leading-tight">Booking Received.</h1>

        {booking ? (
          <div data-testid="booking-confirmation-details" className="mt-10 bg-[#FFFFFF] border border-[#E2D5C3] rounded-3xl shadow-[0_4px_20px_-2px_rgba(35,23,14,0.06)] p-10 text-left">
            <div className="flex justify-between items-baseline pb-6 border-b border-[#E2D5C3]">
              <div>
                <p className="overline">reference</p>
                <p className="font-marcellus text-3xl text-[#A6521B] mt-1">{booking.booking_reference}</p>
              </div>
              <span className="text-xs uppercase tracking-[0.18em] text-[#23170E]/55">{booking.payment_status.replace(/_/g, " ")}</span>
            </div>
            <dl className="grid sm:grid-cols-2 gap-y-4 gap-x-8 mt-6 text-sm">
              <Row k="Tour" v={booking.tour_title} />
              <Row k="Traveler" v={booking.full_name} />
              <Row k="Start date" v={booking.start_date} />
              <Row k="Travelers" v={booking.travelers} />
              <Row k="Accommodation" v={booking.accommodation_tier.replace(/^./, (c) => c.toUpperCase())} />
            </dl>
          </div>
        ) : (
          <p className="mt-10 text-[#23170E]/55">Loading details…</p>
        )}

        <p className="mt-10 text-[#23170E]/65 leading-relaxed max-w-xl mx-auto">
          We've emailed a confirmation to <strong>{booking?.email}</strong>. Our team will follow up within
          24 hours with a personalized itinerary, your quote, and next steps.
        </p>

        <div className="mt-10 flex flex-wrap gap-4 justify-center">
          <Link to="/tours" data-testid="success-explore-more" className="btn-pill btn-pill-outline">
            Explore More Tours
          </Link>
          <a
            href={waLink(
              booking
                ? `Hi APEX, I just submitted inquiry ${booking.booking_reference} for ${booking.tour_title} (${booking.travelers} traveler${booking.travelers > 1 ? "s" : ""}, starting ${booking.start_date}). Could you confirm the next steps?`
                : "Hi APEX, I just submitted a booking inquiry on your website."
            )}
            target="_blank"
            rel="noreferrer"
            data-testid="success-whatsapp"
            className="btn-pill bg-[#25D366] text-white hover:bg-[#1ebd5b]"
          >
            Message Us on WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}

function Row({ k, v }) {
  return (
    <div>
      <dt className="text-xs uppercase tracking-[0.18em] text-[#23170E]/55">{k}</dt>
      <dd className="text-[#23170E] mt-1">{v}</dd>
    </div>
  );
}
